import React from 'react'
import {connect} from 'react-redux'
import {Button, Divider, Form, Input, message, Select, Spin, Typography} from 'antd'

import '../../asset/less/NewPieces.css'
import {putArtworkExhibition} from '../../api/artworkExhibition'
import HttpError from '../../component/base/HttpError'
import FormButton from '../../component/base/FormButton'
import ApplyFormErrorMessage from '../../component/apply/ApplyFormErrorMessage'
import {withRouter} from 'react-router'
import {getUser} from "../../api/user";
import axios from "../../config/axios";
import {adminChangeApplyStatus, getArtist, getArtistPermission} from "../../api/artists";
import {URL_PIECES} from "../../const";

const {Option} = Select
const {Title} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role,
    artists: state.artist.artists
}))
class UserEditAdmin extends React.Component {
    constructor(props) {
        super(props)
        this.expoFormRef = React.createRef()
        this.formRef = React.createRef()
        this.state = {
            validateError: [],
            loading: false,
            artistId: '',
            updateBtnEnabled: true,
            approveLoading: false,
            declineLoading: false,
            formFields: []
        }
        this.is_new = props.new
        this.targetId = -1
        if (!this.is_new) {
            let getExpoId = () => {
                let id = ''
                const locationArry = this.props.location.pathname.split('/')
                if (locationArry.length > 0) {
                    if (locationArry[locationArry.length - 1]) {
                        id = parseInt(locationArry[locationArry.length - 1])
                    } else {
                        id = parseInt(locationArry[locationArry.length - 2])
                    }
                }
                return id
            }
            this.targetId = getExpoId()
        }
        this.CancelToken = axios.CancelToken.source()
    }

    componentDidMount() {
        this.setState({loading: true})
        Promise.all([
            getUser(this.targetId, this.CancelToken),
            getArtist(this.targetId, this.CancelToken),
        ]).then(async (res)=>{
            const userData = res[0].data
            const artistData = res[1].data
            const permissionRes = await getArtistPermission(artistData.id)
            const permissionData = permissionRes.data
            this.setState({
                artistId: artistData.id
            })

            this.setState({
                formFields: [
                    {
                        name: 'date_joined',
                        value: userData.date_joined,
                        disabled: true
                    },
                    {
                        name: 'last_login',
                        value: userData.last_login,
                        disabled: true
                    },
                    {
                        name: 'user_id',
                        value: this.targetId,
                        disabled: true
                    },
                     {
                        name: 'artist_id',
                        value: artistData.id,
                        disabled: true
                    },
                    {
                        name: 'email',
                        value: userData.email,
                        disabled: true
                    },
                     {
                        name: 'is_approved',
                        value: permissionData.is_approved,
                        disabled: true
                    },
                     {
                        name: 'is_pending_approve',
                        value: permissionData.is_pending_approve,
                        disabled: true
                    },
                     {
                        name: 'is_display',
                        value: permissionData.is_display,
                        disabled: true
                    },
                    {
                        name: 'invite_code',
                        value: artistData.invite_code,
                        disabled: true
                    },
                ]
            })
        }).catch((error)=>{
            HttpError(error)
        }).finally(()=>{
            this.setState({
                loading: false
            })
        })
    }

    componentWillUnmount() {
        if(this.state.loading) {
            this.setState({loading: false})
            this.CancelToken.cancel("cancel")
        }
    }

    getFormFields = () => {
        const fields = []
        this.state.formFields.forEach((field)=>{
            fields.push(
             <Form.Item
                name={field.name}
                label={field.name.toUpperCase()}
                initialValue={field.value}
                rules={[
                  {
                    required: false,
                    type: 'string',
                  }
                ]}
              >
                <Input disabled={field.disabled}/>
              </Form.Item>
                )
        })
        return fields
    }

    decline = () => {
        this.setState({declineLoading: true})
        adminChangeApplyStatus(this.targetId, false).then(()=>{
            message.success('Decline Email sent out!').then(r => {})
        }).catch((error)=>{
            HttpError(error)
        }).finally(()=>{
            this.setState({declineLoading: false})
        })
    }

    approve = () => {
        this.setState({approveLoading: true})
        adminChangeApplyStatus(this.targetId, true).then((res)=>{
            message.success('Approve Email sent out!').then(r => {})
        }).catch((error)=>{
            HttpError(error)
        }).finally(()=>{
            this.setState({approveLoading: false})
        })
    }

    render() {

        return (
            <Spin size='large' spinning={this.state.loading}>
                <Title>Edit User (admin)</Title>
                <Divider/>
                <ApplyFormErrorMessage error={this.state.validateError}/>
                <Form
                    labelCol={{span: 6}}
                    wrapperCol={{span: 14, offset: 1}}
                    colon={false}
                    ref={this.formRef}
                >
                    {this.getFormFields()}
                    <Form.Item>
                        <a href={URL_PIECES+"?artistId="+this.state.artistId} target={'_blank'}>View Artworks (View Only Mode)</a>
                    </Form.Item>
                    <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: '8%'}}>
                        <Button type={'ghost'} disabled={false} style={{marginLeft: '10%'}} loading={this.state.declineLoading}
                                onClick={this.decline}>Decline</Button>
                        <Button type={'primary'} style={{marginRight: '10%'}}
                                loading={this.state.approveLoading}
                                onClick={this.approve}>Approve</Button>
                    </div>
                </Form>
            </Spin>
        )
    }
}

export default withRouter(UserEditAdmin)
